<template>
    <div class="o-importantContacts u-py20 u-overflowYAuto">
        <div class="o-importantContacts__inner u-container u-overflowHidden">
            <div v-if="!loading" class="o-importantContacts__content">
                <div v-for="(contactsList, category) in contacts" :key="category" class="o-importantContacts__category">
                    <h2 class="o-importantContacts__title u-colorSecondary">{{ category }}</h2>
                    <div class="o-importantContacts__list u-mb20">
                        <Contact v-for="contact in contactsList" :key="contact.id" :item="contact" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import api from '../services/api';
import Contact from '../components/molecules/Contact.vue';

const contacts = ref({});
const loading = ref(true);

const fetchContacts = async () => {
    try {
        const response = await api.get('/important-contacts');
        if (response.status === 200) {
            contacts.value = response.data;
        }
        loading.value = false;
    } catch (error) {
        console.error('Error fetching contacts:', error);
        loading.value = false;
    }
};

onMounted(() => {
    fetchContacts();
});
</script>